import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const AssignmentList = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const categoryId = searchParams.get("categoryId");
  const categoryName = searchParams.get("categoryName");

  const [assignments, setAssignments] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);

  // Reload when category changes
  useEffect(() => {
    loadAssignments(1);
  }, [categoryId]);

  const loadAssignments = async (page = 1) => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      let url = `${API_URL}/api/assignments?page=${page}&pageSize=10`;

      if (categoryId) {
        url += `&categoryId=${categoryId}`;
      }

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setAssignments(res.data.data);
      setPagination(res.data.pagination);

    } catch (err) {
      console.error("Error loading assignments:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-black text-slate-900">
          {categoryName ? `Assignments - ${categoryName}` : "Assignments"}
        </h2>

        <button
          onClick={() => navigate("/assignments/create")}
          className="bg-indigo-600 text-white px-4 py-2 rounded-xl text-sm font-semibold hover:bg-indigo-700 transition"
        >
          + Create Assignment
        </button>
      </div>

      {/* FILTER INDICATOR */}
      {categoryId && (
        <div className="mb-4 flex items-center gap-3">
          <span className="text-sm text-indigo-600 font-semibold">
            Filtered by Category
          </span>

          <button
            onClick={() => navigate("/assignments/register")}
            className="text-red-500 text-sm font-semibold"
          >
            Clear Filter
          </button>
        </div>
      )}

      {/* KPI */}
      <div className="grid md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white border rounded-xl p-4">
          <p className="text-sm text-slate-400">Active</p>
          <p className="text-lg font-black text-indigo-600">
            {assignments.length}
          </p>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border rounded-2xl overflow-hidden">

        {loading ? (
          <div className="p-6 text-center text-slate-500">
            Loading assignments...
          </div>
        ) : (

          <table className="w-full text-sm">

            <thead className="bg-slate-50 text-slate-500">
              <tr>
                <th className="text-left px-4 py-3">Assignment</th>
                <th className="text-left px-4 py-3">Client</th>
                <th className="text-left px-4 py-3">Category</th>
                <th className="text-left px-4 py-3">Type</th>
                <th className="text-left px-4 py-3">Financial Year</th>
                <th className="text-left px-4 py-3">Status</th>
              </tr>
            </thead>

            <tbody>
              {assignments.map(assignment => (
                <tr
                  key={assignment.AssignmentID}
                  onClick={() =>
                    navigate(`/assignments/${assignment.AssignmentID}`)
                  }
                  className="border-t hover:bg-slate-50 cursor-pointer transition"
                >
                  <td className="px-4 py-3 font-semibold text-slate-900">
                    {assignment.AssignmentName}
                  </td>

                  <td className="px-4 py-3 text-slate-600">
                    {assignment.ClientName}
                  </td>

                  <td className="px-4 py-3 text-slate-600">
                    {assignment.CategoryName || "-"}
                  </td>

                  <td className="px-4 py-3 text-slate-600">
                    {assignment.TypeName || "-"}
                  </td>

                  <td className="px-4 py-3 text-slate-500">
                    {assignment.FinancialYear}
                  </td>

                  <td className="px-4 py-3">
                    <span className="text-xs font-semibold px-2 py-1 rounded-full bg-green-100 text-green-700">
                      {assignment.Status}
                    </span>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
};

export default AssignmentList;
